module.exports = ".emphasys{font-size:22pt;color:#303f9f !important;font-weight:bolder}.subtitle{color:#2D323E !important}\n"